export const DEFAULT_INK = "#000";

export const DEFAULT_ACCENT = "#FF5678";

export interface Props {
  ink?: string;
  accent?: string;
}

